global.jQuery = global.$ = require('jquery');
global.UIkit = require('uikit')
global.ApexCharts = require('apexcharts');
require('select2');
require('./bootstrap');
